// Swatch color fix - applies fallback colors when Shopify native swatch data is missing
document.addEventListener('DOMContentLoaded', function() {

  var colorMap = {
    'Red': '#E31E24',
    'Green': '#00A651',
    'Blue': '#0066B3',
    'Burgundy': '#800020',
    'Dark Blue': '#003366',
    'Navy': '#001f3f',
    'Black': '#000000',
    'White': '#ffffff',
    'Brown': '#8b4513',
    'Gray': '#808080',
    'Grey': '#808080'
  };

  var lightColors = ['White', 'Light Blue', 'Yellow', 'Cream'];

  function applySwatchColors() {
    var swatches = document.querySelectorAll('.swatch--unavailable');

    swatches.forEach(function(swatchElement) {
      // Find the associated input to get the color value
      var label = swatchElement.closest('label');
      if (!label) return;

      var inputId = label.getAttribute('for');
      if (!inputId) return;

      var input = document.getElementById(inputId);
      if (!input || !input.classList.contains('swatch-input__input')) return;

      var colorValue = input.value;
      if (!colorValue) return;

      var color = colorMap[colorValue];
      if (!color) return;

      // We have a color to apply - remove the "no data" class and set background
      swatchElement.classList.remove('swatch--unavailable');
      swatchElement.style.setProperty('--swatch--background', color);

      if (lightColors.indexOf(colorValue) !== -1) {
        swatchElement.style.border = '1px solid #ddd';
      }
    });
  }

  // Apply on initial load
  applySwatchColors();

  // Reapply after Dawn replaces variant HTML (e.g. product swap)
  subscribe(PUB_SUB_EVENTS.variantChange, function() {
    // Small delay to let Dawn finish its HTML replacement
    setTimeout(applySwatchColors, 50);
  });
});
